import React from 'react';
import { Card, Grid, Typography } from '@mui/material';
import useCeludocSection from './useCeludocSection';
import { Stack } from '@mui/system';
import ContainedButton from '../../../../../components/actions/ContainedButton';
import DoctorTelemedicineCard from './components/DoctorTelemedicineCard';
import WorkDaysCard from './components/WorkDaysCard';
import AddDoctorSlots from '../../../../../modals/Doctors/AddDoctorSlots/AddDoctorSlots';
import LoadingContainer from '../../../../../components/loaders/LoadingContainer';
import DoctorChat from './components/DoctorChat';
import CheckboxForm from '../../../../../components/forms/CheckboxForm';
import InputSelectForm from '../../../../../components/forms/InputSelectForm';

const CeludocSection = () => {

    const { 
        loading,
        system, data, actions, telemedicineCtrl, modalManager, doctorDetailsCtrl } = useCeludocSection()
    
    return ( 
        <div>
            <AddDoctorSlots doctor_id={data.iduser} slot_type={data?.telemedicine?.speciality_slot_type_id}
            open={modalManager.modals.add_slots} 
            onClose={() => modalManager.onChangeModalStatus('add_slots', false)}
            onRefresh={() => actions.onGetDoctorSlots()}/>
            <LoadingContainer loading={loading}>
                <Stack spacing={2}>
                    <Card sx={{ p: 3 }}>
                    
                            <>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant='subtitle1' sx={{mb:1}}>Funcionalidades</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <CheckboxForm
                                                    id='enabled_pharmacy'  value={doctorDetailsCtrl.boolean_form.enabled_pharmacy}
                                                    label='¿Habilitar farmacia?'
                                                    onChange={doctorDetailsCtrl.onChangeBooleanForm}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <CheckboxForm
                                                    id='private_chat'  value={doctorDetailsCtrl.boolean_form.private_chat}
                                                    label='¿Habilitar chat?'
                                                    onChange={doctorDetailsCtrl.onChangeBooleanForm}
                                                />
                                            </Grid>
                                            {!!doctorDetailsCtrl.boolean_form.enabled_pharmacy && <Grid item xs={12}>
                                                <InputSelectForm 
                                                    data={doctorDetailsCtrl.form.pharmacy_id}
                                                    onChange={doctorDetailsCtrl.onChangeBooleanForm}
                                                />
                                            </Grid>}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DoctorChat 
                                            form={doctorDetailsCtrl.form}
                                            onChange={doctorDetailsCtrl.onChangeForm}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DoctorTelemedicineCard
                                            telemedicine={data.telemedicine} 
                                            form={telemedicineCtrl.form} 
                                            onChange={telemedicineCtrl.onChangeForm} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        
                                    </Grid>

                                </Grid>
                                <Stack alignItems='flex-end' sx={{pt:3}}>
                                    <ContainedButton loading={system.sending} onClick={actions.onSubmit}>
                                        Guardar
                                    </ContainedButton>
                                </Stack>
                            </>
                        
                    </Card>
                    <Card sx={{ p: 3 }}>
                        <WorkDaysCard workdays={data?.workdays}
                            onAddSlots={() => modalManager.onChangeModalStatus('add_slots', true)}
                            onDeleteSlot={actions.onDeleteSlot}
                        />
                    </Card>
                </Stack>
            </LoadingContainer>
        </div>
     );
}
 
export default CeludocSection;